<template>
  <div style="width:100%">
    <v-autocomplete v-model="shipmentZoneId" :outlined="outlined" dense :label="label"
                    :items="[{name:noneText,id:null,level:0},{divider:true},...shipmentZones]"
                    item-text="name" item-value="id" @change="select()" :disabled="disabled">
      <template v-slot:prepend-item v-if="allowAdd">
        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="showCreate()">
          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new shipment zone
        </div>
      </template>
      <template v-slot:item="{item}">
        <v-list-item-content>{{item.name}}</v-list-item-content>
      </template>
      <template v-slot:prepend>
        <slot name="prepend"/>
      </template>
    </v-autocomplete>

    <v-dialog v-model="createShipmentZone" persistent max-width="400">
      <v-card>
        <v-card-title>Create shipment zone</v-card-title>
        <v-divider/>
          <v-form v-model="valid" immediate ref="form" class="mt-4">
            <v-container>
              <v-row dense>
                <v-col cols="6">
                  <v-text-field label="Name" v-model="shipmentZone.name" :rules="[fieldRules.required,fieldRules.maxLength(20)]" outlined dense :counter="20" autofocus/>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn plain color="primary" @click="createShipmentZone=false">Cancel</v-btn>
          <v-btn color="primary" @click="create()" :loading="busy">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'SalesShipmentZonesSelect',
  props: {
    value: {required: false, type:String},
    label: {required: false, type:String},
    allowAdd: {required: false, type:Boolean, default:false},
    name: {required: false, type:String},
    noneText: {required: false, type:String, default:''},
    outlined: {required: false, type:Boolean, default:true},
    disabled: {required: false, type:Boolean, default:false}
  },
  data() {
    return {
      shipmentZoneId: this.value,
      shipmentZones: [],
      createShipmentZone: false,
      shipmentZone: {},
      valid: true,
      busy: false
    }
  },
  watch: {
    value() {
      this.shipmentZoneId = this.value;
    }
  },
  async created() {
    this.shipmentZones = [];
    await this.$lazyListLoad(this.shipmentZones, 'shipmentZones', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$emit('update:name', this.shipmentZones.find(c => c.id === this.shipmentZoneId)?.name);
  },
  methods: {
    select() {
      this.$emit('input', this.shipmentZoneId);
      this.$emit('change', this.shipmentZoneId);
      this.$emit('update:name', this.shipmentZones.find(c => c.id === this.shipmentZoneId)?.name);
    },
    showCreate() {
      this.shipmentZone = {name:'',active:true};
      this.createShipmentZone = true;
      this.$nextTick(() => this.$refs.form.validate());
    },
    async create() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.busy = true;
      const results = await this.$apiCall(`mutation SalesShipmentZonesSelect($input: ShipmentZoneInput!) {
                                             shipmentZoneCrupdate(input:$input) {id,name}
                                          }`, {input:this.shipmentZone});
      this.busy = false;
      if (!results.error) {
        this.shipmentZoneId = results.data.shipmentZoneCrupdate.id;
        this.shipmentZones.push(results.data.shipmentZoneCrupdate);
        this.select();
        this.createShipmentZone = false;
      }
    }
  }
}
</script>